// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"5bdb384c","277":"a42e4e08","506":"3d42c807","740":"e9f285bd"}[chunkId] + ".chunk.css";
};